<script setup lang="ts">
definePageMeta({
  layout: 'documents'
})
</script>

<template>
  <section class="section">
    <h1 class="headline-2 title">Terms of use</h1>

    <div class="paragraf top-paragraf">
      <p class="date font-links">
        Last update: <data class="text-m" value="2024-12-27">27.12.2024</data>
      </p>
      <p class="font-bodytext">
        Infinity Bytes Software Design L.L.C Terms and Conditions
      </p>

      <p class="font-bodytext">
        Welcome to
        <nuxt-link class="link" to="https://www.switchcase.dev"
          >Switchcase.dev</nuxt-link
        >. These Terms and Conditions (“Terms”) govern your use of our website,
        <nuxt-link class="link" to="https://www.switchcase.dev"
          >www.switchcase.dev</nuxt-link
        >
        (the “Platform”).
      </p>

      <p class="font-bodytext">
        By using the Platform, you agree to be bound by these Terms and our
        Privacy Policy. If you do not agree, you should not use the Platform.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">1. Use of the platform</h2>
      <p class="paragraf-text font-bodytext">
        The Platform is provided for informational purposes and to allow you to
        contact us via our feedback form. You agree to use the Platform only for
        lawful purposes and in a way that does not infringe the rights of,
        restrict, or inhibit anyone else’s use of the Platform.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">2. Information you provide</h2>
      <p class="paragraf-text font-bodytext">
        When you use our contact form, you may provide your name and email
        address. You agree that any information you submit is accurate and does
        not violate any laws or the rights of third parties.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">3. Intellectual property</h2>
      <p class="paragraf-text font-bodytext">
        All content, design, text, graphics, and other materials on the Platform
        are owned by
        <nuxt-link class="link" to="https://www.switchcase.dev"
          >Switchcase.dev</nuxt-link
        >
        or its licensors and are protected by applicable intellectual property
        laws. You may not copy, reproduce, distribute, or otherwise use our
        content without our prior written permission.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">4. Limitation of liability</h2>
      <p class="paragraf-text font-bodytext">
        The Platform is provided “as is” without any warranties of any kind.
        <nuxt-link class="link" to="https://www.switchcase.dev"
          >Switchcase.dev</nuxt-link
        > shall not be liable for any loss or damage arising from
        your use of the Platform.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">5. Changes to the terms</h2>
      <p class="paragraf-text font-bodytext">
        We may update these Terms from time to time. Changes take effect
        immediately upon posting on the Platform. Your continued use of the
        Platform after changes means you accept the updated Terms.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">6. Governing law</h2>
      <p class="paragraf-text font-bodytext">
        These Terms are governed by the laws of UAE (United Arab Emirates). Any
        disputes will be subject to the exclusive jurisdiction of the courts in
        UAE jurisdiction.
      </p>
    </div>

    <div class="paragraf">
      <h2 class="font-title paragraf-title">7. Contact information</h2>
      <p class="paragraf-text font-bodytext">
        For questions about these Terms, please contact us at:
      </p>
      <nuxt-link class="link font-bodytext" to="mailto:info@switchcase.dev"
        >info@switchcase.dev</nuxt-link
      >
    </div>
  </section>
</template>

<style scoped>
.section {
  padding: 132px 0 120px;
  width: 100%;
  max-width: 660px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 40px;
}

.title {
  text-transform: uppercase;
}

.paragraf {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.paragraf-title {
  margin-bottom: 24px;
}

.paragraf-text {
  margin-bottom: 15px;
}

.paragraf-text:last-child {
  margin-bottom: 0;
}

.top-paragraf {
  gap: 16px;
}

.date {
  text-transform: uppercase;
}

.link {
  color: var(--main-blue);
  text-decoration: none;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
}

.list-item-bullet {
  filter: blur(0.7px);
  flex-shrink: 0;
}

.list-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
}

@media (max-width: 1200px) {
  .section {
    max-width: 756px;
  }
}

@media (max-width: 1023px) {
  .section {
    gap: 32px;
    padding: 112px 20px 60px;
  }

  .top-paragraf {
    gap: 12px;
  }

  .paragraf-title {
    margin-bottom: 20px;
  }

  .paragraf-text {
    margin-bottom: 10px;
  }

  .list {
    gap: 2px;
  }
}

@media (max-width: 743px) {
  .paragraf-text {
    margin-bottom: 12px;
  }
}
</style>
